exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#button .dx-button-content {\r\n    padding: 0;\r\n}\r\n\r\n#button .button-indicator {\r\n    height: 32px;\r\n    width: 32px;\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n    margin-right: 5px;\r\n}\r\n\r\n\r\n#currencyButton .dx-button-content {\r\n    padding: 0;\r\n}\r\n\r\n#currencyButton .button-indicator {\r\n    height: 32px;\r\n    width: 32px;\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n    margin-right: 5px;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./App/containers/data/data.css
// module id = 1327
// module chunks = 0